// [z-paging]常量

const version = '2.2.1';
const delayTime = 100;
const i18nUpdateKey = 'z-paging-i18n-update';
const errorUpdateKey = 'z-paging-error-emit';
const completeUpdateKey = 'z-paging-complete-emit';

export default {
	version,
	delayTime,
	i18nUpdateKey,
	errorUpdateKey,
	completeUpdateKey
}